
export default function MissionSection() {
  return (
    <section className="py-16 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div>
            <h2 className="text-4xl font-bold text-gray-900 mb-6">Our Mission</h2>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              At NextZen Soccer Academy, our mission is to provide exceptional soccer training that goes beyond just developing athletic skills. We are committed to nurturing young athletes aged 4-18 in Folsom, CA, helping them build confidence, character, and a lifelong love for the beautiful game.
            </p>
            <p className="text-lg text-gray-700 mb-6 leading-relaxed">
              We believe that soccer is more than just a sport – it's a platform for personal growth, teamwork, and building lasting friendships. Our comprehensive programs are designed to meet each player where they are and help them reach their full potential both on and off the field.
            </p>
            <div className="flex items-center space-x-4">
              <div className="w-16 h-16 bg-purple-100 rounded-full flex items-center justify-center">
                <i className="ri-trophy-line text-2xl text-purple-600"></i>
              </div>
              <div>
                <h3 className="text-xl font-semibold text-gray-900">Excellence in Every Touch</h3>
                <p className="text-gray-600">Striving for greatness in every aspect of training and development</p>
              </div>
            </div>
          </div>
          <div className="relative">
            <img 
              src="https://public.readdy.ai/ai/img_res/045aac7e59f872fd06b83a193d3b85bc.jpg"
              alt="Soccer training session"
              className="w-full h-96 object-cover rounded-lg shadow-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
